module.exports = __webpack_public_path__ + "img/Clark_Lucy2020-06-24.79632e07.png";